import { render, staticRenderFns } from "./HomeChatPanel.vue?vue&type=template&id=8ebd84d4&scoped=true"
import script from "./HomeChatPanel.vue?vue&type=script&lang=js"
export * from "./HomeChatPanel.vue?vue&type=script&lang=js"
import style0 from "./HomeChatPanel.vue?vue&type=style&index=0&id=8ebd84d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebd84d4",
  null
  
)

export default component.exports